import moment from 'moment';
import jsSHA from 'jssha';
import axios from 'axios';
import { LocalStorageUtils } from '@/utils';

export const BACKEND_URL = import.meta.env.VITE_APP_BACKEND_URL;

export const apiClient = axios.create({
  baseURL: BACKEND_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

export const signedApiClient = (method: string, uri: string) => {
  //checking cached user before adding auth headers
  if (LocalStorageUtils.getUserKeys()) {
    const signingObj = signingString(method, `${BACKEND_URL}/${uri}`);
    apiClient.defaults.headers.common['X-Date'] = signingObj.date;
    apiClient.defaults.headers.common['Authorization'] = signingObj.string;
  } else {
    delete apiClient.defaults.headers.common['X-Date'];
    delete apiClient.defaults.headers.common['Authorization'];
  }
  return apiClient;
};

interface SigningObject {
  date: string;
  string: string;
}

const hexToBase64 = (hexstring: string): string => {
  const processedHex: string = hexstring
    .match(/\w{2}/g)!
    .map((a: string) => {
      return String.fromCharCode(parseInt(a, 16));
    })
    .join('');
  return btoa(processedHex);
};
  
const hexToArrayBuffer = (hex: string): Uint8Array => {
  const view = new Uint8Array(hex.length / 2);
  
  for (let i = 0; i < hex.length; i += 2) {
    view[i / 2] = parseInt(hex.substring(i, i + 2), 16);
  }
  
  return view;
};
  
const stringToArrayBuffer = (str: string): Uint8Array => {
  const enc = new TextEncoder(); // always utf-8
  return enc.encode(str);
};

export const signingString = (
  method: string,
  url: string
): SigningObject => {
  let keyData: string = '';
  const localKeys = LocalStorageUtils.getUserKeys();
  if (localKeys) {
    keyData = localKeys.data as string;
  }
  const parsedUrl = '/' + url.split('/').slice(3).join('/');
  const b64KeyUri = hexToBase64(localKeys?.key ?? '');
  const date = moment().utc().format('ddd, D MMM YYYY HH:mm:ss [GMT]');
  const shaObj = new jsSHA('SHA-256', 'ARRAYBUFFER');
  shaObj.setHMACKey(hexToArrayBuffer(keyData as string), 'ARRAYBUFFER');
  shaObj.update(stringToArrayBuffer(method + ' ' + parsedUrl + ' HTTP/1.1\ndate: ' + date));
  const b64Hmac = shaObj.getHMAC('B64');

  const signingObj: SigningObject = {
    date: date,
    string: `Signature keyId="${b64KeyUri}",algorithm="hmac-sha256",headers="request-line date",signature="${b64Hmac}"`
  };

  return signingObj;
};
